import { ca } from '@cian/analytics';

type TPage = {
  dealType?: string | null;
  objectType?: string | null;
  offerID?: number;
  offerPhone?: string;
  pageType?: string;
  siteType?: string;
  extra: {
    filter_rating: number;
    rating: number | null;
  };
};

export function tracFilterAnalyticClick({ page }: { page: TPage }) {
  ca('eventSite', {
    action: 'Click_sopr',
    category: 'NewbuildingReviews',
    label: 'Filter',
    name: 'oldevent',
    useLastProducts: true,
    page,
  });
}
